module.exports = __webpack_public_path__ + "img/balance.2c6081e6.svg";